import React, { useState } from 'react'
import { useHistory } from "react-router-dom";
import LikeComment from './LikeComment'
import VerticalLine from "../../common/images-new/vertical-line2.svg"
import hmenu_user from "../../common/images-new/no-profile-pic.png";
import moment from "moment";
import axios from 'axios';
import { serverUrl } from '../Helpers/Config';
import { ActiveIconColor, BgComment, BgWhite, ButtonCommonTop, PublishIcon, TextBlack, TextGray, TextGreen, ButtonCommonDelete } from '../../pages/Theme';
import { FaTrashAlt } from 'react-icons/fa';
import { TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { getUrl } from '../Helpers/Config';
import { styled } from '@mui/styles';
import { staticFiles } from '../Helpers/Static';
import { MdOutlinePublic } from 'react-icons/md';
import Tooltip from '@mui/material/Tooltip';
import { IoMdLock } from 'react-icons/io';
const CustomTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        border: 'none',
        '&:hover': {
            border: 'none',
        },
        '&.Mui-focused': {
            border: 'none',
        },
    },
});

const styles = {
    root: {
        "& .MuiInputBase-root.Mui-disabled": {
            "& > fieldset": {
                borderColor: "white",
                color: 'black',

            }
        },
        '& .MuiOutlinedInput-root': {
            fontWeight: 'normal',
            fontSize: '13px',
            padding: '10px !important',
            '& fieldset': {
                borderColor: "white",
                color: 'black',
                fontWeight: 'normal',
                fontSize: '13px',
            },
            '&:hover fieldset': {
                borderColor: "#FFFFFF",
            },
            '&.Mui-focused fieldset': {
                borderColor: '#FFFFFF'
            },
        },
    },
};

const Comment = ({
    profilePic, username, order,
    createdOn, comment, isLiked,
    numLikes, numComments,
    handleDelete, publicView,
    deleteView, userId, guID,
    isView, isPrivate
}) => {
    //add prop: replyList
    let replyListDummy = [{
        profilePic,
        username,
        createdOn, comment,
        numLikes, numComments
    }, {
        profilePic,
        username,
        createdOn,
        comment,
        numLikes,
        numComments
    }]

    const history = useHistory()

    const [dropdown, setDropdown] = useState(false)
    const toggleDropdown = () => {
        setDropdown(!dropdown)
    }

    // const classes = useStyles();

    // const navigateprofile = () => {
    //     history.push(`/userprofiledata`, { user_id: userId });
    // }
    return (
        <div>
            {order > 0 && <hr className="self-center" />}
            <div className="py-2">
                <div className="flex flex-col sm:flex-row relative pt-2 gap-2">
                    <a target="_blank" href={getUrl("/profile/") + guID}>
                        <img className="h-10 w-10 rounded-full cursor-pointer" src={profilePic ? profilePic : staticFiles?.noProfilePic} alt="profile"></img></a>
                    <div className="flex flex-col mr-10 text-left cursor-pointer">
                        <a target="_blank" href={getUrl("/profile/") + guID} className='path-navigate'>
                            <div className='flex gap-2 items-center'>
                                <p className="text-base font-semibold blackColor">{username}</p>
                                <p className="text-sm font-normal lightColor pt-0.5">
                                    {moment.utc(createdOn).local().startOf('seconds').fromNow()}
                                </p>
                            </div>
                        </a>
                    </div>
                    {isView == false ? "" : <>
                        {deleteView == true ?
                            <div className="flex flex-row items-center absolute right-0">
                                {isPrivate == true ?
                                    <Tooltip title={"Public comment"} className='z-50' placement="top" arrow>
                                        <span className='z-50 cursor-auto'>
                                            <MdOutlinePublic className='w-5 h-5 -mt-0.5 z-50 primaryIcon' />
                                        </span>
                                    </Tooltip> :
                                    <Tooltip title={"Private comment"} className='z-50' placement="top" arrow>
                                        <span className='z-50 cursor-auto'>
                                            <IoMdLock className='w-5 h-5 -mt-0.5 z-50 secondaryIcon' />
                                        </span>
                                    </Tooltip>}
                            </div> : <>
                                {publicView !== true ?
                                    <div className="flex flex-row items-center absolute right-0">
                                        <div className="flex items-center " >
                                            <ul className="flex gap-1">
                                                <li className=''>
                                                    {isPrivate == true ?
                                                        <Tooltip title={"Public comment"} className='z-50' placement="top" arrow>
                                                            <span className='z-50 cursor-auto'>
                                                                <MdOutlinePublic className='w-5 h-5 -mt-0.5 z-50 primaryIcon' />
                                                            </span>
                                                        </Tooltip> :
                                                        <Tooltip title={"Private comment"} className='z-50' placement="top" arrow>
                                                            <span className='z-50 cursor-auto'>
                                                                <IoMdLock className='w-5 h-5 -mt-0.5 z-50 secondaryIcon' />
                                                            </span>
                                                        </Tooltip>}
                                                </li>
                                                <li onClick={handleDelete}>
                                                    {/* <ButtonCommonDelete className="p-2.5 cursor-pointer rounded-lg"> */}
                                                    <Tooltip title={"Delete comment"} className='z-50' placement="top" arrow>
                                                        <span className='z-50 cursor-auto'>
                                                            <FaTrashAlt className='deleteColor cursor-pointer opacity-60 hover:opacity-100 w-4 h-4' />
                                                        </span>
                                                    </Tooltip>
                                                    {/* </ButtonCommonDelete> */}
                                                    {/* <ButtonCommonDelete>
                                                        <FaTrashAlt
                                                            className="cursor-pointer opacity-60 hover:opacity-100 w-4 h-4"
                                                        />
                                                    </ButtonCommonDelete> */}
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                    :
                                    null
                                }
                            </>}</>
                    }

                </div>
                {/* <p className=" mt-2">{comment}</p> */}
                <div className='sm:pl-11 sm:-mt-5'>
                    <span className={`${deleteView ? "multiline-ellipsis3" : ""} commentStyle`}>{comment}</span>
                    {/* <TextField
                        value={comment}
                        multiline
                        maxRows={deleteView ? 3 : ''}
                        fullWidth
                        InputProps={{ readOnly: true }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                padding: '6px !important',
                            },
                            '& .MuiInputBase-input': {
                                textAlign: "justify",
                                overflow: deleteView ? 'hidden' : 'visible !important',
                                textOverflow: "ellipsis",
                                padding: '0px !important',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                        }}
                    /> */}
                </div>
                {/* <p className="text-gray-500 flex justify-end cursor-pointer hover:text-gray-800">reply</p> */}
                {/* <div className="flex flex-row relative mt-3">
                    <LikeComment numLikes={numLikes} numComments={numComments} isLiked={isLiked}/>
                    
                </div> */}


            </div>
            {/* Reply section */}
            {false && replyListDummy &&
                <div className="mt-1">
                    {replyListDummy.map((reply, index) => (
                        <div className="flex flex-row ml-2" key={index}>
                            <img className="mr-5" src={VerticalLine}></img>
                            <div className="flex flex-col justify-center">
                                <div className="flex flex-row ">
                                    <img className="h-10 w-10 mr-4 rounded-full" src={reply.profilePic} alt="profile"></img>
                                    <div className="flex flex-col mr-10 text-left">
                                        <p className="text-base text-black font-semibold">{reply.username}</p>
                                        <p className="text-sm text-gray font-normal">
                                            {moment.utc(createdOn).local().startOf('seconds').fromNow()}
                                        </p>
                                    </div>
                                </div>
                                <p className="text-black">{reply.comment}</p>
                            </div>
                        </div>
                    ))}
                </div>
            }
        </div >
    )
}

export default Comment